export default __webpack_public_path__ + "static/media/icon-Training-Knowledge-Base.1f1a5828.svg";